import React from "react";
import { api } from "@/lib/api";
import { SafeHTML } from "@/components/site/RichTextEditor";

/**
 * Renders admin-editable HTML sections (blocks) for a given page slug.
 * Place anywhere in a page; admin can create blocks targeting that page.
 */
export default function PageBlocks({ slug, className = "" }) {
  const [blocks, setBlocks] = React.useState([]);

  React.useEffect(() => {
    api.get("/page-blocks", { params: { page_slug: slug } }).then((r) => setBlocks(r.data)).catch(() => {});
  }, [slug]);

  if (!blocks.length) return null;

  return (
    <div className={`grid gap-5 ${className}`} data-testid={`page-blocks-${slug}`}>
      {blocks.map((b) => (
        <article key={b.id} className="neo-card p-5 sm:p-6 bg-white" data-testid={`page-block-${b.id}`}>
          {b.title && <h3 className="font-display font-black text-xl sm:text-2xl tracking-tighter uppercase mb-3">{b.title}</h3>}
          <SafeHTML html={b.html} />
        </article>
      ))}
    </div>
  );
}
